import { SideMenuProvider } from '@/components/CompanyOverview/components/SideMenu/context';
import { useCompanyCanonicalUrl } from '@/hooks/useCompany';
import { useCompanySplitDetect } from '@/hooks/useCompanySplitDetect';
import useUser from '@/hooks/useUser';
import loadable from '@loadable/component';
import DwellTrackingProvider from './components/DwellTrackingProvider';
import ReportSplitHandlerProvider from './components/ReportSplitHandlerProvider';

const CompanySplit = loadable(() => import('./CompanySplit'));
const CompanyOverview = loadable(() => import('@/containers'), {
  resolveComponent: (components) => components.CompanyOverview,
});
const Stream = loadable(() => import('@/components/Company/Stream'), {
  ssr: false,
});

function CompanySplitSwitcher() {
  const isSplit = useCompanySplitDetect();
  const canonicalUrl = useCompanyCanonicalUrl();
  const { data: user } = useUser();
  return (
    <SideMenuProvider>
      <>
        {user.loggedIn && <Stream />}
        {/* key is used to refresh component state when visiting new company */}
        {isSplit ? (
          <ReportSplitHandlerProvider key={canonicalUrl}>
            <DwellTrackingProvider>
              <CompanySplit />
            </DwellTrackingProvider>
          </ReportSplitHandlerProvider>
        ) : (
          <CompanyOverview />
        )}
      </>
    </SideMenuProvider>
  );
}
export default CompanySplitSwitcher;
